import routerHelper from "helpers/routerHelper";
import { autoinject } from "aurelia-framework";
import { PurchaseOrderService } from "services/purchase-order-service";
import { I18N } from "aurelia-i18n";
import { bindable } from "aurelia-typed-observable-plugin";

@autoinject
export class MaterialOrderMemo {

    public readonly: boolean = false;
    public dispatchProjectCode: any = null;
    public orderId: any = null;
    public extension: any = null;
    public memo: string | null = "";
    public element: HTMLTextAreaElement | null = null;
    @bindable public purchaseOrder: any = null;

    private minPaddingNoScroll: number = 2;

    constructor(private readonly i18n: I18N, private readonly purchaseOrderService: PurchaseOrderService) {}

    public async activate(params: any): Promise<void> {
        this.purchaseOrder = await this.purchaseOrderService.GetPurchaseOrder(params.orderId, params.extension);
        this.dispatchProjectCode = params.dispatchProjectCode;
    }

    public attached(): void {
        this.resize();
    }

    public close(): void {
        routerHelper.navigateBack();
    }

    public async save(): Promise<void> {
        await this.purchaseOrderService.SaveProjectPurchaseOrderHeader(this.dispatchProjectCode, this.purchaseOrder).then(async (success: any) => {
            if (success) {
                routerHelper.navigateBack();
            }
        });
    }

    private resize(): void {
        if (this.element) {
            this.element.style.width = "100%";
            this.element.style.height = this.element.scrollHeight + this.minPaddingNoScroll + "px";
        }
    }
}
